
<script>
import AddNodeBtn from "@/components/DrawFlow/src/components/AddNodeBtn";
import RowFactory from "@/components/DrawFlow/src/components/DrawRow/FactoryRow";
// import EventBus from "@/components/ApprovalProcess/ProcessDesign/components/EventBus/EventBus";

import {
  RowNode,
  ConditionNode,
  CopyNode,
} from "./components/NodeConfigFactory/NodeFactory";
// import { deepClone } from "@/common/utils";
import FlowFactory from "./components/factory";
import { HashCode, transToTreeDat } from "./utils";
import FlowNode from "@/components/DrawFlow/src/components/DrawRow/FlowNode";
export default {
  name: "FactoryDrawFlow",
  components: {
    AddNodeBtn,
    FlowNode,
  },
  created() {
    this.init();
    // this.creatBusNodeChange();  // 可用事件派发
  },
  props: {
    FlowConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    nextSteup: {
      type: Function,
      default() {
        return () => {
          return true;
        };
      },
    },
  },
  watch: {
    FlowConfig: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  data() {
    return {
      rectTypeDic: {
        1: "审批节点",
        2: "规则节点",
        3: "抄送人",
        4: "开始节点",
      },
      isColList: ["3", "5"],
      selfConfig: null,
      currentNode: null,
      //缓存数据
      cacheData: null,
    };
  },
  methods: {
    // 节点数据变化事件
    nodeChange(node) {
      this.currentNode.title = node.title;
      this.currentNode.content = node.content;
      this.selfConfig.forEach((i) => {
        if (i.id === this.currentNode.id) {
          i.data = node.data;
          i.content = node.content;
          i.title = node.title;
        }
      });
      this.$forceUpdate();
    },
    /**
     * 添加条件框
     */
    addBranch(node) {
      console.log(node, "添加条件copy");
      // this.$emit("clickNode", node[0]);
      if(node.length>=10){
        this.$message.error('最多添加10个条件分支');
        return;
      }
      let row = new CopyNode(node[0]);
      let valueisArray = Array.isArray(node[0].value); //判断value是不是数组
      let length_ = node.length;
      let newNode = {
        ...row,
        content:'请选择',
        title:`条件${length_ }`,
        isParent:false,
        condition:'',
        value:valueisArray?[]:'',
        value2:'',
        valueName:'',
      }
      this.selfConfig.push(newNode);
      //以下为了排序
      let elseBranchIndex = this.selfConfig.findIndex(i => i.content == '默认进入本流程' && i.groupId== node[0].groupId && i.type=='3' );
      let branchRow = this.selfConfig[elseBranchIndex];
      this.selfConfig.splice(elseBranchIndex,1);
      this.selfConfig.push(branchRow);
      console.log(this.selfConfig, 'this.selfConfig');
    },
    creatBusNodeChange() {
      // EventBus.$on("nodeChange", this.nodeChange);
    },
    getResData() {
      let list = JSON.parse(JSON.stringify(this.selfConfig));
      this.transformTree(list);
      list.forEach((i) => {
        if (i.isRow) {
          delete i.childNode;
        }
      });

      list = this.shakeDeleteNode(list);
      return list;
    },
    /**
     * 删除没有上级的节点
     *  已废弃
     * @obsolete
     */
    shakeDeleteNode(list) {
      console.log(selfConfig, "list");
      let root = JSON.parse(JSON.stringify(list)).filter((i) => i.isRoot)[0];
      let selfConfig = JSON.parse(JSON.stringify(list)).filter(
        (i) => !i.isRoot
      );
      const ids = list.map((i) => i.id);
      console.log(ids, "ids");
      let hasNoPidNode = false;
      // 删除pids没有id的节点
      selfConfig.forEach((i) => {
        if (i.pids.some((j) => !ids.includes(j))) {
          hasNoPidNode = true;
          selfConfig = this.deleteNode(selfConfig, i);
        }
      });
      if (root) selfConfig.unshift(root);
      if (hasNoPidNode) return this.shakeDeleteNode(selfConfig);
      return selfConfig;
    },
    /**
     * 初始化 数据私有化
     */
    init() {
      this.selfConfig = JSON.parse(JSON.stringify(this.FlowConfig));
    },
    /**
     *  @param data  源数组一维数组
     *  @requires  tree 二维数组
     */
    transformTree(data) {
      return transToTreeDat(data);
    },
    clickSelectBox(nextNode, pidNode) {
      if (!this.nextSteup(nextNode, pidNode)) return;
      let { node, selfConfig } = this.getNodeFactory(nextNode);
      if (nextNode.type == "3") {
        //条件分支弹窗选择条件分支
        this.$emit("addConditionBranch", node, nextNode);
      } else {
        let row = node[0];
        console.log(row, "新增的");
        // 按顺序插入
        let parentIndex = selfConfig.findIndex((i) => i.id === row.groupId);
        if (parentIndex !== -1) {
          selfConfig.splice(parentIndex + 1, 0, row);
          this.selfConfig = selfConfig;
        } else {
          selfConfig.push(row);
          this.selfConfig = selfConfig;
        }
        this.$emit("selectNode", row);
      }
      console.log(this.selfConfig, "this.selfConfig");
      // this.selfConfig = selfConfig.concat(node);
    },
    //条件分支弹窗选完添加节点方法
    addNodeFromCondition(node) {
      this.selfConfig = this.selfConfig.concat(node);
    },
    addNodeFromCondition2(list, nextNode) {
      let {id = ''} = nextNode;
      let rowIdIndex = this.selfConfig.findIndex((i) => i.groupId === id && i.type!='3');
      let notrowIdIndex = this.selfConfig.findIndex((i) => i.groupPid === id && i.type == '3');
      let forGroupId = null;
      if(notrowIdIndex>-1){
        forGroupId = this.selfConfig[notrowIdIndex].groupId;
      }
      let { node, selfConfig } = this.getNodeFactory2(nextNode, list);
      let row = node[0];
      // 按顺序插入
      let parentIndex = selfConfig.findIndex((i) => i.id === row.groupPid);
      if (parentIndex !== -1) {
        if(rowIdIndex !== -1) {
        selfConfig[rowIdIndex].groupId = row.groupId;
        this.repickArr(this.selfConfig[rowIdIndex]);
        } else if(notrowIdIndex !== -1){
          selfConfig.forEach((item,index) =>{
            if(item.groupId == forGroupId){
              item.groupPid = row.groupId;
              this.repickArr(selfConfig[index]);
            }
          })
        }
        selfConfig.splice(parentIndex + 1, 0, ...node);
        this.selfConfig = selfConfig;
      } else {
        if(rowIdIndex !== -1) {
        selfConfig[rowIdIndex].groupId = row.groupId;
        this.repickArr(this.selfConfig[rowIdIndex]);
        }else if(notrowIdIndex !== -1){
          selfConfig.forEach((item,index) =>{
            if(item.groupId == forGroupId){
               item.groupPid = row.groupId;
               this.repickArr(selfConfig[index]);
            }
          })
        }
        this.selfConfig = selfConfig.concat(node);
      }
      
      
      // this.selfConfig = selfConfig.concat(node);
    },
    editNode(currNode, list) {
      //先删除所有groupId节点相同的，
      this.selfConfig = this.selfConfig.filter(
        (item) => item.groupPid !== currNode.groupPid
      );
      console.log(this.selfConfig, "filterselfConfig");
      //再走新增的逻辑，但是要带上上一个节点的groupPid

      let { node, selfConfig } = this.getNodeFactory2(currNode, list);
      let node_ = [...node];
      node_.forEach((item) => {
        item.groupPid = currNode.groupPid;
      });
      let row = node_[0];
      let parentIndex = selfConfig.findIndex((i) => i.id === row.groupPid);
      if (parentIndex !== -1) {
        selfConfig.splice(parentIndex + 1, 0, ...node);
        this.selfConfig = selfConfig;
      } else {
        this.selfConfig = selfConfig.concat(node);
      }
      // this.selfConfig = this.selfConfig.concat(node_);
      console.log(this.selfConfig, "this.selfConfigthis.selfConfig");
    },
    /**
     * 根据isRow去判断row或者rol
     */
    getNodeFactory(nextNode) {
      if (!nextNode.isRow) {
        let { node, selfConfig } = this.getColNode(nextNode);
        return { node, selfConfig };
      } else {
        let { node, selfConfig } = this.getRowNode(nextNode);
        return { node, selfConfig };
      }
    },
    getNodeFactory2(nextNode, list) {
      if (!nextNode.isRow) {
        let { node, selfConfig } = this.getColNode2(nextNode, list);
        return { node, selfConfig };
      } else {
        let { node, selfConfig } = this.getRowNode(nextNode);
        return { node, selfConfig };
      }
    },
    /**
     * 获取row节点
     */
    getRowNode(nextNode) {
      let node = [new RowNode(nextNode)];
      let selfConfig = this.repickArr(node[0]);
      // this.clickNode(node[0]);
      return { node, selfConfig };
    },
    /**
     * 获取col节点
     */
    getColNode(nextNode) {
      let groupId = HashCode();
      let node = [
        new ConditionNode({ groupId, ...nextNode }),
        new ConditionNode({ groupId, ...nextNode }),
      ];
      node.forEach((item, index) => {
        item.title = `条件${index + 1}`;
        if (index === node.length - 1) {
          item.title = `其他条件`;
        }
      });
      console.log(node, "node~~~~");
      console.log(node[0], "node000~~~~");
      let repickConfig = {
        groupId: node[0].groupPid,
        id: node[0].id,
      };
      let selfConfig = this.repickArr(repickConfig);
      this.locationScroll();
      return { node, selfConfig };
    },
    getColNode2(nextNode, list) {
      let groupId = HashCode();
      let node = [];
      for (let i = 0; i < list.length; i++) {
        let item = new ConditionNode({ groupId, ...nextNode });
        node.push({
          ...item,
          ...list[i],
          branchValueList: list,
        });
      }
      node.forEach((item, index) => {
        item.title = `条件${index + 1}`;
        if (index === node.length - 1) {
          item.title = `其他条件`;
        }
      });
      console.log(node, "getColNode2---node");
      let repickConfig = {
        groupId: node[0].groupPid,
        id: node[0].id,
      };
      console.log(repickConfig, "repickConfig---node");
      let selfConfig = this.repickArr(repickConfig);
      this.locationScroll();
      return { node, selfConfig };
    },
    /**
     * 定位滚动条
     */
    locationScroll() {
      // window.location.hash = ".bottom-right-cover-line";
      let el = document.getElementsByClassName("dingflow-design")[0];
      setTimeout(() => {
        el.scrollLeft = el.scrollWidth - el.clientWidth + 340;
      }, 0);
    },
    /**
     * 重定位数组
     */
    repickArr(repickConfig) {
      let selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      selfConfig.forEach((i) => {
        if (i.isRow) {
          if (i.groupId === repickConfig.groupId) {
            i.groupId = repickConfig.id;
          }
        } else {
          if (i.groupPid === repickConfig.groupId) {
            i.groupPid = repickConfig.id;
          }
        }
      });
      return selfConfig;
    },
    // 点击节点
    clickNode(nodeConfig) {
      console.log("ccccc");
      this.currentNode = nodeConfig;
      this.$emit("clickNode", nodeConfig);
    },

    //点击关闭节点
    closeNode(node) {
      console.log("关闭节点", node);
      let repickConfig = {};
      if (node.isRow) {
        repickConfig.groupId = node.groupId;
        repickConfig.id = node.id;
        let selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
        this.selfConfig = this.deleteNode(selfConfig, node);
        this.repickDeleteArr(repickConfig);
      } else {
        this.deleteColNode(node);
      }
    },
    selectNode(nodeConfig) {
      console.log(nodeConfig, "点击右箭头");
      this.$emit("selectNode", nodeConfig);
    },
    // 删除节点
    deleteNode(selfConfig, node) {
      console.log(selfConfig, "selfConfig");
      selfConfig = selfConfig
        .map((i) => {
          if (i.id !== node.id) {
            if (!i.childNode) return i;
            if (i.childNode.id === node.id) delete i.childNode;
            return i;
          }
        })
        .filter(Boolean);
      console.log(selfConfig, "selfConfigend");

      return selfConfig;
    },
    //单独删除col下node
    deleteColNode(node) {
      let selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      console.log(selfConfig.length, "selfConfigselfConfig");
      let nodeArr = selfConfig.filter(
        (i) => i.groupId === node.groupId && !i.isRow
      );
      let deleteArr = [];
      let repickConfig;
      if (nodeArr.length > 2) {
        //递归删除所有关联子节点
        deleteArr = [node];
        this.deleteLoop(selfConfig, node, deleteArr);
        repickConfig = {
          id: node.id,
          groupId: node.groupId,
        };
      } else {
        //删除整个group
        let allCol = selfConfig
          .map((i) => i.groupId === node.groupId && !i.isRow && i)
          .filter(Boolean);
        deleteArr = allCol;
        // allCol.forEach((i) => {
        //   this.deleteLoop(selfConfig, i, deleteArr);
        // });
        repickConfig = {
          id: node.groupId,
          groupId: node.groupPid,
        };
      }
      console.log(deleteArr, "deleteArrdeleteArr");
      deleteArr.forEach((i) => {
        selfConfig = this.deleteNode(selfConfig, i);
      });
      let deleteGroupId = node.groupId;
      let branchList = selfConfig.filter(
        (i) => i.groupId === deleteGroupId && !i.isRow
      );
      console.log(branchList, "branchList");
      if (branchList.length) {
        branchList.forEach((item, index) => {
          let configIndex = selfConfig.findIndex((i) => i.id == item.id);
          selfConfig[configIndex].title =
            index != branchList.length - 1 ? `条件${index + 1}` : "其他条件";
        });
      }
      this.selfConfig = selfConfig;
      this.repickDeleteArr(repickConfig);
      return selfConfig;
    },
    // 循环遍历删除组下关联节点
    deleteLoop(selfConfig, node, deleteArr) {
      // 获取当前节点下所有关联节点
      let currentDeleteArr = selfConfig.filter((i) => {
        if (i.isRow) {
          return i.groupId === node.id;
        } else {
          // return i.groupPid === node.id || i.groupPid === node.groupId;
          return i.groupPid === node.id 
        }
      });
      if (currentDeleteArr.length) {
        currentDeleteArr.forEach((i) => {
          deleteArr.push(i);
          this.deleteLoop(selfConfig, i, deleteArr);
        });
      } else {
        return;
      }
    },
    //判断是否是row
    judgeNodeIsRow(node) {
      return node.isRow;
    },
    //删除后重组数组
    repickDeleteArr(repickConfig) {
      let selfConfig = JSON.parse(JSON.stringify(this.selfConfig));
      console.log("selfConfig", selfConfig);
      selfConfig.forEach((i) => {
        if (i.isRow && i.groupId === repickConfig.id) {
          i.groupId = repickConfig.groupId;
        } else if (!i.isRow && i.groupPid === repickConfig.id) {
          i.groupPid = repickConfig.groupId;
        }
      });
      this.selfConfig = selfConfig;
    },
    //绘制body
    drawBody(h, node) {
      if (node.childNode) {
        return FlowFactory.getFactory.bind(this, h, node.childNode)();
      } else {
        return <div></div>;
      }
    },
  },
  destroyed() {
    // EventBus.$off("nodeChange");
  },
  render(h) {
    // this.init();
    let FlowConfig = JSON.parse(JSON.stringify(this.selfConfig));
    FlowConfig = this.transformTree(FlowConfig);
    this.cacheData = FlowConfig;
    const root = JSON.parse(JSON.stringify(this.selfConfig[0]));
    return (
      <div class="design-engine">
        <div class="dingflow-design">
          <div class="ie-polyfill-container">
            <div class="box-scale" id="box-scale">
              {RowFactory.nodeWrapRender.bind(this, h, root)()}
              {this.drawBody(h, FlowConfig[0])}
              <div class="end-node">
                <div class="end-node-circle"></div>
                <div class="end-node-text">流程结束</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
};
</script>

<style scoped lang="scss">
.design-engine {
  position: relative;
  height: 100%;
  .dingflow-design {
    width: 100%;
    // background-color: #f5f5f7;
    overflow: auto;
    height: 100%;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    ::v-deep .ant-popover-arrow {
      display: none !important;
    }
    .ie-polyfill-container {
      display: -ms-grid;
      -ms-grid-columns: min-content;
      .box-scale {
        transform: scale(1);
        display: inline-block;
        position: relative;
        width: 100%;
        padding: 54.5px 0;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        min-width: -webkit-min-content;
        min-width: -moz-min-content;
        min-width: min-content;
        // background-color: #f5f5f7;
        -webkit-transform-origin: 0 0 0;
        transform-origin: 50% 0px 0px;
        .end-node {
          border-radius: 50%;
          font-size: 14px;
          color: rgba(25, 31, 37, 0.4);
          text-align: left;
          .end-node-circle {
            width: 10px;
            height: 10px;
            margin: auto;
            border-radius: 50%;
            background: #dbdcdc;
          }
          .end-node-text {
            margin-top: 5px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
